import './ContactIcons.css';

function ContactIcons() {
  return (
    <div>
      <a href="https://www.linkedin.com/in/kieran-stewart/" class="contact-item">
        <svg viewBox="0 0 24 24" class="icon">
          <path
            d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8h4V24h-4V8zm7.5 0h3.8v2.2h.1c.5-1 1.8-2.2 3.8-2.2 4 0 4.7 2.6 4.7 6V24h-4v-7.8c0-1.9 0-4.2-2.6-4.2s-3 2-3 4V24h-4V8z" />
        </svg>
        LinkedIn
      </a>
      <br/>
      <a href="https://github.com/KieranStewart" class="contact-item">
        <svg viewBox="0 0 24 24" class="icon">
          <path
            d="M12 .5C5.73.5.5 5.73.5 12c0 5.1 3.29 9.43 7.86 10.96.58.1.79-.25.79-.56v-2.1c-3.2.7-3.87-1.54-3.87-1.54-.53-1.34-1.3-1.7-1.3-1.7-1.06-.72.08-.7.08-.7 1.17.08 1.78 1.2 1.78 1.2 1.04 1.78 2.73 1.27 3.4.97.1-.76.4-1.27.72-1.56-2.55-.3-5.23-1.28-5.23-5.7 0-1.26.45-2.3 1.2-3.12-.12-.3-.52-1.52.12-3.17 0 0 .97-.3 3.18 1.2a11 11 0 0 1 5.8 0c2.2-1.5 3.17-1.2 3.17-1.2.64 1.65.24 2.87.12 3.17.75.82 1.2 1.86 1.2 3.12 0 4.44-2.7 5.4-5.27 5.7.42.36.78 1.07.78 2.17v3.22c0 .31.2.67.8.56A10.99 10.99 0 0 0 23.5 12C23.5 5.73 18.27.5 12 .5z" />
        </svg>
        GitHub
      </a>
      <br/>

      <a href="mailto:kieran-stewart@proton.me" class="contact-item">
        <svg viewBox="0 0 24 24" class="icon">
          <path d="M12 13.5 1.5 6h21L12 13.5zm0 2.25L1.5 7.5V18h21V7.5L12 15.75z" />
        </svg>
        Email Me
      </a>
    </div>
  );
}

export default ContactIcons;